import {addLike} from '../../../../assets/javascripts/helpers/ajax.js';
import AriaButton from '../aria-button/aria-button.js';

class LikeButton extends AriaButton {
    constructor() {
        super();
        this.addEventListener('click', this._onClick);
    }

    async _onClick() {
        try {
            const articleId = this.getAttribute('data-article');
            const likeCount = await addLike(articleId);

            this.lastElementChild.textContent = likeCount;
        } catch {
            // do nothing
        }
    }
}

customElements.define('like-button', LikeButton);
export default LikeButton;
